export const ADD_TIME_TO_LESSON = "ADD_TIME_TO_LESSON";
export const LOADED_WATCHED_LESSONS = "LOADED_WATCHED_LESSONS";
export const UPDATE_QUIZ_ATTEMPT = "UPDATE_QUIZ_ATTEMPT";
export const COMPLETE_QUIZ = "COMPLETE_QUIZ";
export const LOADED_QUIZ_ATTEMPTS = "LOADED_QUIZ_ATTEMPTS";
export const LOADED_PROGRESS = "LOADED_PROGRESS";
export const LOADED_CONVERSATIONS = "LOADED_CONVERSATIONS";
